import { render, staticRenderFns } from "./Block1Item.vue?vue&type=template&id=137b713b&scoped=true&"
import script from "./Block1Item.vue?vue&type=script&lang=js&"
export * from "./Block1Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b713b",
  null
  
)

export default component.exports